<template>
  <div class="card edit_setting">
    <div class="header">
      <h4 class="title">
        {{ new_setting.module_name }} / {{ new_setting.key_name }}
      </h4>
    </div>
    <div class="content">
      <form>
        <div class="row">
          <div class="col-md-12" v-if="new_setting.key_val.length < 60">
            <fg-input
              v-model="new_setting.key_val"
              type="text"
              :placeholder="new_setting.key_name"
            />
          </div>
          <div class="col-md-12" v-else>
            <div class="form-group">
              <textarea
                v-model="new_setting.key_val"
                rows="3"
                class="form-control border-input"
                :placeholder="new_setting.key_name"
              />
            </div>
          </div>
        </div>
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="updateSetting"
          >
            <!-- {{ translate(upd_ip.id ? "ip_profile.update":"ip_profile.add") }} -->
            Save
          </button>
          <button
            type="submit"
            class="btn btn-danger btn-fill btn-wd"
            @click.prevent="cancel"
          >
            Cancel
          </button>
        </div>
        <div class="clearfix" />
      </form>
    </div>
  </div>
</template>
<script>
export default {
  name: "GlobalSettingsEdit",
  props: ['setting'],
  data () {
    return {
      new_setting: {}
    }
  },
  created () {
    this.new_setting = {...this.setting}
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    updateSetting () {
      this.$http.v1.updateSettings(this.new_setting.id, {key_val: this.new_setting.key_val}, (response) => {
        if (response.data.status == "OK") {
          this.global_notify('info', this.translate('global_settings.save_setting'))
          this.$emit('update')
          this.$emit('close')

        }else{
          this.global_notify('danger', this.translate('global_settings.error_save_setting'))
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .edit_setting {
    .header{
      .title{
        text-align: center;
      }
    }
  }
</style>
